// Decorative homepage modules only. Commerce and above-fold components stay eager.
const selector = '[data-deferred-section-module]';
const imports = new Map();
const observed = new Set();
const load = (element) => {
  if (!element.isConnected) return;
  const url = element.getAttribute('data-deferred-section-module');
  if (!url) return;
  let pending = imports.get(url);
  if (!pending) {
    pending = import(url);
    imports.set(url, pending);
    pending.catch(() => imports.delete(url));
  }
  pending.then(() => {
    observer?.unobserve(element);
    observed.delete(element);
  }).catch((error) => {
    // Preserve the rendered text; another intersection can retry a failed request.
    console.warn('Decorative section module could not load', error);
  });
};
const eager = window.Shopify?.designMode || !('IntersectionObserver' in window);
const observer = eager ? null : new IntersectionObserver((entries) => {
  for (const entry of entries) {
    if (entry.isIntersecting) load(entry.target);
  }
}, { rootMargin: '600px 0px' });
const scan = (root) => {
  const elements = [...root.querySelectorAll(selector)];
  if (root.matches?.(selector)) elements.unshift(root);
  for (const element of elements) {
    if (observed.has(element)) continue;
    if (!observer) load(element);
    else {
      observed.add(element);
      observer.observe(element);
    }
  }
};
scan(document);
document.addEventListener('shopify:section:load', (event) => scan(event.target));
document.addEventListener('shopify:section:unload', (event) => {
  for (const element of observed) {
    if (event.target.contains(element)) {
      observer?.unobserve(element);
      observed.delete(element);
    }
  }
});
